import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'
import doorControl from './door_module'
import sysManage from './sys_manage'
import applyBase from './apply_basic'
import consume from './consume'
import payment from './payment'
import order from './order'
import program from './program'
// import language from './language'
import erp from './erp'

Vue.use(Vuex)

export default new Vuex.Store({
  state,
  actions,
  mutations,
  getters,
  modules: {
    doorControl,
    sysManage,
    applyBase,
    consume,
    payment,
    order,
    program,
    // language
    erp
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js